import React, { useEffect, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';

const CthIssueView = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);
    console.log(formData)

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    // var sizes = formData.size ? formData.size.split(',') : 0;
    // // var percent = valueLoss / 100;
    // // var percentProfit = profit / 100;
    // var itemData = [
    //     {
    //         size: formData.size ? formData.size.split(',') : 0,
    //         avgM: formData.m0_avg ? formData.m0_avg : 0,
    //         avgM1: formData.m1_avg > 0 ? formData.m1_avg : 0,
    //         avgM2: formData.m2_avg > 0 ? formData.m2_avg : 0,
    //         avgM3: formData.m3_avg > 0 ? formData.m_avg : 0,
    //     }
    // ];

    // const renderTableRow = (size, index) => {
    //     const newAvgM = itemData.map((val) => val.avgM[index] || 0);
    //     const newAvgM1 = itemData.map((val) => val.avgM1[index] || 0);
    //     const newAvgM2 = itemData.map((val) => val.avgM2[index] || 0);
    //     const newAvgM3 = itemData.map((val) => val.avgM3[index] || 0);

    //     let m0rate = formData.m0rate ? formData.m0rate : 0;
    //     let m1rate = formData.m1rate ? formData.m1rate : 0;
    //     let m2rate = formData.m2rate ? formData.m2rate : 0;
    //     let m3rate = formData.m3rate ? formData.m3rate : 0;

    //     let outSrc = formData.outSrc ? formData.outSrc : 0;

    //     let mCal = m0rate * outSrc / 100 + parseFloat(m0rate);
    //     let m1Cal = m1rate * outSrc / 100 + parseFloat(m1rate);
    //     let m2Cal = m2rate * outSrc / 100 + parseFloat(m2rate);
    //     let m3Cal = m3rate * outSrc / 100 + parseFloat(m3rate);

    //     let fm0 = mCal * newAvgM / 100;
    //     let fm1 = m1Cal * newAvgM1 / 100;
    //     let fm2 = m2Cal * newAvgM2 / 100;
    //     let fm3 = m3Cal * newAvgM3 / 100;

    //     let clothrate = fm0 + fm1 + fm2 + fm3;
    //     let jobrate = formData.jobrate ? parseFloat(formData.jobrate) : 0;
    //     let calJob = Math.round(clothrate) + jobrate;
    //     let extra = formData.extra ? parseFloat(formData.extra) : 0;
    //     let cost = Math.round(calJob) + extra;

    //     let firmPer = formData.firmPer ? parseFloat(formData.firmPer) : 0;
    //     let mrp = formData.mrp ? parseFloat(formData.mrp) : 0;

    //     let profit = cost * firmPer / 100;
    //     let finalRate = Math.round(profit + cost);

    //     let calMrp1 = mrp / 100;
    //     let calMrp2 = 1 - calMrp1;
    //     let finalMrp = Math.round(finalRate / calMrp2);

    //     let mod = finalMrp % 5;
    //     if (mod > 2.5) {
    //         let diff = 5 - mod;
    //         var ans = finalMrp + Math.round(diff);
    //     } else {
    //         ans = finalMrp - Math.round(mod);
    //     }
    //     return (
    //         <TableRow key={index}>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{size}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM1}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM2}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{newAvgM3}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(clothrate)}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(calJob)}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(cost)}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(profit)}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(finalRate)}</TableCell>
    //             <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{Math.round(ans)}</TableCell>
    //         </TableRow>
    //     );
    // };


    return (
        <>
            <div style={{ margin: '1% 0%', width: '100%' }}>

                <h3 className='centered-heading'>Item View</h3>
                <div className="dashed-line"></div>

                <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                    <tbody>

                        <tr>
                            <td style={{ width: '200px' }}>Item Name :</td>
                            <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                            <td style={{ width: '200px', paddingLeft: '2%' }}>Total Mtr. :</td>
                            <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.totmtr}</td>
                        </tr>

                    </tbody>

                </table>


                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                    <Table>
                        <TableHead>
                            <TableRow className='tbl-row'>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth Name</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bale No.</TableCell>
                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Bale Mtr.</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                formData?.cloths?.map((item, index) => (
                                    <TableRow key={index}>
                                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{index + 1}</TableCell>
                                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{item.clothNm}</TableCell>
                                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{item.baleNo}</TableCell>
                                        <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }}>{item.givenMtr}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </>
    );
};

export default CthIssueView;
